<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<span v-html="resp" />
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		resp: {
			type: Object,
			required: true,
		},
	},
};
</script>
